import { publish } from "./utils/pubsub";
export var triggerBeforePageView = function(url) {
    return publish("beforePageView", url);
};
export var triggerPageView = function(url) {
    return publish("pageView", url);
};
export var triggerBeforeHistoryChange = function(url) {
    return publish("beforeHistoryChange", url);
};
// These two events inform lapel that page loading is happening
export var triggerPageLoadBegin = function() {
    return publish("pageLoadBegin");
};
export var triggerPageLoadComplete = function() {
    return publish("pageLoadComplete");
};

//# sourceMappingURL=events.js.map